import bouncy from '../elements/bouncy.js';
bouncy.register();
